import React from "react";

const CalculatorIcon = () => {
  return (
    <svg width="13" height="17" viewBox="0 0 13 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.625 0C0.727188 0 0 0.727188 0 1.625V14.625C0 15.5228 0.727188 16.25 1.625 16.25H11.375C12.2728 16.25 13 15.5228 13 14.625V1.625C13 0.727188 12.2728 0 11.375 0H1.625ZM1.625 1.625H11.375V3.25H1.625V1.625ZM1.625 4.875H11.375V14.625H1.625V4.875ZM3.25 6.5V8.125H4.875V6.5H3.25ZM5.6875 6.5V8.125H7.3125V6.5H5.6875ZM8.125 6.5V8.125H9.75V6.5H8.125ZM3.25 8.9375V10.5625H4.875V8.9375H3.25ZM5.6875 8.9375V10.5625H7.3125V8.9375H5.6875ZM8.125 8.9375V10.5625H9.75V8.9375H8.125ZM3.25 11.375V13H4.875V11.375H3.25ZM5.6875 11.375V13H9.75V11.375H5.6875Z"
        fill="#2B56A3"
      />
    </svg>
  );
};

export default CalculatorIcon;
